<template>
  <div>
    <b-row class="mb-3">
      <b-col>
        <p class="text-dark font-size-h5 font-weight-bold mb-3">
          Thông tin khách hàng
        </p>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="3">
        <b-form-group class="required-control">
          <label>Loại dịch vụ</label>
          <b-form-select
            size="sm"
            class="select-style"
            :value="warranty.warrantyServiceId"
            :options="warrantyServiceOptions"
            value-field="id"
            text-field="name"
            :disabled="isEditMode && !canUpdateServiceType"
            @input="$emit('update-field', 'warrantyServiceId', $event)"
          >
            <template v-slot:first>
              <b-form-select-option :value="null"
                >--Chọn loại dịch vụ--</b-form-select-option
              >
            </template>
          </b-form-select>
        </b-form-group>
      </b-col>
      <b-col cols="3">
        <CustomerPhoneSearch
          :value="warranty.customerPhone"
          @input="$emit('update-field', 'customerPhone', $event)"
          @customer-found="$emit('customer-found', $event)"
          @customer-cleared="$emit('customer-cleared')"
          :required="true"
        />
      </b-col>
      <b-col cols="3">
        <b-form-group class="required-control">
          <label>Họ và tên</label>
          <b-form-input
            size="sm"
            :value="warranty.customerName"
            @input="$emit('update-field', 'customerName', $event)"
            placeholder="Nhập hoặc chọn từ SĐT"
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col cols="3">
        <b-form-group>
          <label>Số liên hệ</label>
          <b-form-input
            size="sm"
            :value="warranty.customerContactNumber"
            @input="$emit('update-field', 'customerContactNumber', $event)"
            placeholder="Nhập số liên hệ"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="3">
        <b-form-group>
          <label>Email</label>
          <b-form-input
            size="sm"
            type="email"
            :value="warranty.customerEmail"
            @input="$emit('update-field', 'customerEmail', $event)"
            placeholder="Nhập email"
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col cols="6">
        <b-form-group>
          <label>Địa chỉ</label>
          <b-form-input
            size="sm"
            :value="warranty.customerAddress"
            @input="$emit('update-field', 'customerAddress', $event)"
            placeholder="Nhập địa chỉ"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import CustomerPhoneSearch from './CustomerPhoneSearch.vue';

export default {
  name: 'WarrantyCustomerInfoSection',
  components: {
    CustomerPhoneSearch,
  },
  props: {
    warranty: {
      type: Object,
      required: true,
    },
    warrantyServiceOptions: {
      type: Array,
      default: () => [],
    },
    isEditMode: {
      type: Boolean,
      default: false,
    },
    canUpdateServiceType: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

